import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './i18n'; // ← مهم

import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from 'i18next'; // ← نحتاج نجيب اللغة الحالية

const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ حدد الاتجاه حسب اللغة
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

root.render(
  <React.StrictMode>
    <div dir={direction} lang={i18n.language}>
      <App />
    </div>
  </React.StrictMode>
);

reportWebVitals();
